// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import MintUI from 'mint-ui'
import Meta from 'vue-meta'
import wx from 'weixin-js-sdk'
import ElementUI from 'element-ui'
import BaiduMap from 'vue-baidu-map'

import 'mint-ui/lib/style.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/index.js'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'sGyOTKb2y6z0Wi2qOiQbnkcx2SKGUaMU'
})
Vue.use(MintUI)
Vue.use(Meta)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.wx = wx

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js